import { useQuery } from '@tanstack/react-query';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '~/primitives/dialog';
import { LevelRecordEntry } from '~/components/LevelRecordEntry';
import { ModalProps } from '~/util';
import { useList } from '~/util/hooks/useList';
import { countryLevelRecordsQuery } from '~/util/queries/public/profiles';
import { BaseLevel } from '~/util/types/levels';
import { Country } from 'iso-3166-1/dist/iso-3166';
import { ScrollArea } from '~/primitives/scroll-area';

type CountryLevelRecordsDialogProps = {
    level: BaseLevel;
    country: Country;
} & ModalProps;

export const CountryLevelRecordsDialog = ({
    level,
    country,
    ...modalProps
}: CountryLevelRecordsDialogProps) => {
    const list = useList();

    const records =
        useQuery(
            countryLevelRecordsQuery({
                list,
                country: Number(country.numeric),
                levelid: level.id,
            }),
        )?.data ?? [];

    return (
        <Dialog {...modalProps}>
            <DialogContent disableDialogScroll className="w-2xl">
                <DialogHeader>
                    <DialogTitle>Country Records for {level.name}</DialogTitle>
                    <DialogDescription>
                        {records.length} member{records.length !== 1 ? 's' : ''}{' '}
                        of {country.country}{' '}
                        {records.length !== 1 ? 'have' : 'has'} completed this
                        level.
                    </DialogDescription>
                </DialogHeader>
                <ScrollArea className="min-h-0 flex-1 mt-3">
                    {records.map((record) => (
                        <LevelRecordEntry
                            key={record.id}
                            record={record}
                            showDetailsOnTheSide
                        />
                    ))}
                </ScrollArea>
            </DialogContent>
        </Dialog>
    );
};
